module.exports = __webpack_public_path__ + "img/Pista_20.95a6cd81.png";